
import Vue from 'vue';
import { APP_ERROR_EVENT } from '../../../../constants';
import { Core } from '../../../../services/core';
import { OptionPartEntity, OptionPartsStore } from '../../../../services/parts';

export default Vue.extend({
  name: 'partsOptionsView',
  data() {
    return {
      isMounted: false,
      isLoading: false,

      metadata: {
        option: undefined as OptionPartEntity | undefined,
      },
    };
  },

  beforeMount() {
    this.$metronic.breadcrumbs.setBreadcrumbs([
      { title: 'Parts', route: '/parts' },
      { title: 'Options', route: '/parts/options' },
    ]);
  },

  async mounted() {
    this.$set(this, 'isLoading', true);
    try {
      const [entity] = await Promise.all([OptionPartsStore.get(this.$route.params.guid)]);

      this.$set(this.metadata, 'option', entity);
    } catch (e) {
      console.error(e);
      Core.Eventhub.emit(APP_ERROR_EVENT, e);
      return;
    } finally {
      this.$set(this, 'isMounted', true);
      this.$set(this, 'isLoading', false);
    }

    this.$metronic.breadcrumbs.appendBreadcrumb({
      title: this.metadata.option?.description as string,
    });
  },
});
